import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "people",
  "use": "people-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"people\">\r\n<g>\r\n\t<circle cx=\"10.5\" cy=\"5.5\" r=\"3.5\" />\r\n\t<path d=\"M10.5,10C6.9,10,4,12.2,4,15v2h13v-2C17,12.2,14.1,10,10.5,10z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol